import lodash, { forEach, forOwn } from 'lodash';
import * as filterBuilder from './apiFilterBuilder';


export const getApiSort = (sortParam) => {
  let sort = []
  if (sortParam) {
    sort.push({
      "attributeName": sortParam.substring(1),
      "direction": sortParam[0] === '-' ? 'DESC' : 'ASC'
    })
  }
  return sort
}


export const getApiPaging = (offset, limit) => {
  const pageSize = limit || 10

  return {
    pageNumber: (offset || 0) / pageSize,
    pageSize: pageSize
  }
}


export const getApiFilterBuilder = filterString => {
  return filterBuilder.init(filterString)
}

